/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

export default {
    getAll: async (params) => exeRequest(`/admin/contrats${buildQuery(params)}`, "GET"),

    getById: async (id) => exeRequest(`/admin/contrats/${id}`, "GET"),

    create: async (data) => exeRequest(`/admin/contrats`, "POST", data),

    update: async (id, data) => exeRequest(`/admin/contrats/${id}`, "PUT", data),

    delete: async (id, params = {}) => exeRequest(`/admin/contrats/${id}${params.force ? '?force=true' : ''}`, "DELETE"),

    renouveler: async (id) => exeRequest(`/admin/contrats/${id}/renouveler`, "POST"),

    getHistorique: async (id) => exeRequest(`/admin/contrats/${id}/historique`, "GET"),

    echelonner: async (id, data) => exeRequest(`/admin/contrats/${id}/echelonner`, "POST", data),

    getEcheancesMois: async () => exeRequest(`/admin/contrats/echeances-mois`, "GET"),

    getEcheancesListe: async (params) => exeRequest(`/admin/contrats/echeances-liste${buildQuery(params)}`, "GET"),

    getStats: async (params = {}) => exeRequest(`/admin/contrats/stats${buildQuery(params)}`, "GET"),
};
